import * as React from 'react';
export var Palette = Object.freeze({
  primary: 'primary',
  neutral: 'neutral',
  info: 'info',
  danger: 'danger',
  success: 'success',
  white: 'white'
});
export var Tone = Object.freeze({
  dark: 'dark',
  light: 'light'
});
export var Size = Object.freeze({
  small: 'small',
  medium: 'medium'
});
export var Appearance = Object.freeze({
  solid: 'solid',
  outline: 'outline'
});